// src/stateManagers/services/authService.ts
import axios from 'axios';
import Cookies from 'js-cookie';
import { API_BASE_URL } from '../../apiSetup/apiConfig';

const COOKIE_OPTIONS = {
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'Lax' as const,
  path: '/',
};

export interface LoginResponse {
  status: string;
  message: string;
  token: string;
  refresh_token: string;
}

export const login = async (username: string, password: string) => {
  const response = await axios.post<LoginResponse>(`${API_BASE_URL}api/login-v2`, {
    username,
    password,
  });

  if (response.data.status !== 'success') {
    throw new Error(response.data.message || 'Login failed');
  }

  Cookies.set('accessToken', response.data.token, COOKIE_OPTIONS);
  Cookies.set('refreshToken', response.data.refresh_token, COOKIE_OPTIONS);

  return response;
};

export const logout = async (_accessToken: string, _refreshToken: string) => {
  // No /api/logout route registered yet — clearing cookies client-side only.
  // Swap this for a real API call once the backend adds the endpoint.
  Cookies.remove('accessToken', COOKIE_OPTIONS);
  Cookies.remove('refreshToken', COOKIE_OPTIONS);
};

export const logoutAllDevices = async (_accessToken: string) => {
  // Same caveat — no backend route for this yet.
  Cookies.remove('accessToken', COOKIE_OPTIONS);
  Cookies.remove('refreshToken', COOKIE_OPTIONS);
};